export default "/dist/files/rubrique_animations.a83747cafaaa85885dffc5ae83963b28.svg";